import { getDocHeight, getCookie } from "./helpers/utils";

const ACTION = "gama_loadmorenews"

const CAPTION_CLASS = "caption"
const GRID_CLASS = "news-grid"
const ITEM_CLASS = "grid-item"

const GRID_SELECTOR = "." + GRID_CLASS
const ITEM_SELECTOR = "." + ITEM_CLASS
const LOADMORE_SELECTOR = ".load-more"
const QUERY_SELECTOR = ".filters"

const PAGED = "news_paged"

class GamaNews {
  constructor() {
    this._perpage = 8
    this._request = null
    this._window = window
    this._document = document
    this._LoadMore = document.querySelector(LOADMORE_SELECTOR)
    this._query = document.querySelector(QUERY_SELECTOR)

  }

  async query(pckr) {
    let dt = new FormData()
    dt.append('action', ACTION)
    dt.append('per_page', this._perpage)
    dt.append('paged', sessionStorage.getItem(PAGED) )

    this._request = await fetch( ajax.url, {
      method: 'POST',
      credentials: "same-origin",
      cache: "no-cache",
      body: dt,
    })
    .then( response => response.json() )
    .then( json => {
      sessionStorage.setItem(PAGED, json.paged)
      let obj = json.data
      for (var i = 0; i < obj.length; i++) {
        let item = obj[i]
        let news = document.createElement("div")
        let box = document.createElement("div")
        let caption = document.createElement("div")
        let image = document.createElement("div")
        let thu = document.createElement("img")
        let title = document.createElement("h4")
        let date = document.createElement("h6")
        let excerpt = document.createElement("p")
        let a = document.createElement("a")
        a.href = item.url
        caption.classList.add("caption")
        caption.classList.add("d-flex")
        caption.classList.add("flex-column")
        box.classList.add("d-flex")
        box.classList.add("flex-row")
        box.classList.add("justify-content-start")
        box.classList.add("pt-3")
        box.classList.add("pb-3")
        image.classList.add("thumbnail")
        thu.src = item.thumbnail
        image.appendChild(thu)
        title.innerHTML = item.title
        excerpt.innerHTML = item.excerpt
        date.innerHTML = item.post_date
        box.appendChild(image)
        caption.appendChild(title)
        caption.appendChild(date)
        caption.appendChild(excerpt)
        box.appendChild(caption)
        a.appendChild(box)
        news.classList.add("grid-item")
        news.classList.add("mt-3")
        news.appendChild(a)
        console.log("here")
        this._document.querySelector(GRID_SELECTOR).appendChild(news)
      }
    })
    .catch( (error) => {
      // silence is golden
    })

  }

  static init() {
    let q = new GamaNews()
    let grid = document.querySelector(GRID_SELECTOR)
    let _debounce
    if (grid) {
      clearTimeout(_debounce)
      _debounce = setTimeout(() => {
        q.query(null)
        LoadMore.style.visibility = "visible";
      }, 500)
    }
    window.addEventListener('scroll', function(e) {
      if (grid) {
        if ((window.innerHeight + window.scrollY) >= getDocHeight(document)) {
          clearTimeout(_debounce)
          _debounce = setTimeout(() => {
            q.query(null)
            LoadMore.style.visibility = "visible";
          }, 500)
        }
      }
    }, { passive: true });
  }
}

window.addEventListener('DOMContentLoaded', (e) => {
  sessionStorage.setItem(PAGED, 1)
  GamaNews.init()
});



export default GamaNews
